import React from "react";
import "./DataGrid.scss";


interface IDataGrid extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    title: string;
    toolbar?: JSX.Element;
    records: any[];
    onSort?: (key:string)=>void;
    children: (JSX.Element | null | undefined | false)[] | JSX.Element;
    rowProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}

export function DataGrid({ title, toolbar, records, children, rowProps={}, onSort, ...props }: IDataGrid) {
    const childrenArray: JSX.Element[] = Array.isArray(children) ? children.filter(el=>!!el) : [children].filter(el=>!!el)
    const colunms = childrenArray?.map((element: any) => [element.props.label || "--",  element.key || "--"])
    return (
        <div className='DataContent' {...props}>
            <h1 className='text-30' style={{width: "100%"}}>{title}</h1>
            {toolbar}
            <div className='DataGrid__wrapper'>
                <div className='DataGrid' style={{ gridTemplateColumns: `repeat(${childrenArray.length}, 1fr)` }}>
                    {colunms?.map(([label, key]: string[]) =>
                        <div className='DataGrid__head cursor-pointer' onClick={()=>onSort ? onSort(key): null}>
                            <span className='text-12 secondary uppercase'>{label || key}</span>
                        </div>
                    )}
                    {
                        records?.map((record: any) => (
                            childrenArray.map((element: any) => (
                                <div id={record.id} className='DataGrid__cell' {...rowProps}>
                                    {React.cloneElement(element, { value: record[element.key] || element.empty || "--", record: record })}
                                </div>
                            ))
                        ))
                    }
                </div >
            </div>
        </div>
    )
}